import React from 'react';
import { Resizable } from 'react-resizable';
import './ResizableTitle.css';

const ResizableTitle = props => {
  const { onResize, width, ...restProps } = props;

  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable
      width={width}
      height={0}
      handle={<span className="react-resizable-handle" onClick={e => e.stopPropagation()} />}
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
      minConstraints={[10, 0]}
      maxConstraints={[1000, 0]}
    >
      <th {...restProps} />
    </Resizable>
  );
};

export default ResizableTitle;
